import { Pipe, PipeTransform } from '@angular/core';
import { SubpageAppEntitySubpageRead } from '../openapi';

@Pipe({
  name: 'subpageContentByUrl',
  standalone: true
})
export class SubpageContentByUrlPipe implements PipeTransform {

  transform(items: SubpageAppEntitySubpageRead[], url: string): SubpageAppEntitySubpageRead | null {
    return items.filter(v => v?.url === url)[0] || null;
  }

}
